module.exports = __webpack_public_path__ + "img/vent.83376081.svg";